import ChromeCastController from "controllers/ChromeCastController";
//import * as actions from "./actions";

export const sendMessage = (msg: any) => {
  ChromeCastController.sendMessage(msg);
};

export const loadTestConfig = (config: any) => {
  console.log("cc loadTestConfig - disabled");
  //ChromeCastController.loadTestConfig(config);
};

export const loadQuizConfig = (quizData: any) => {
  console.log("cc loadQuizConfig - disabled");
  //ChromeCastController.loadQuizConfig(quizData);
};

export const connect = (data: any) => {
  ChromeCastController.connect(data);
};

export const loadConfig = (user: any, quizID: any) => {
  ChromeCastController.loadConfig(user, quizID);
};

export const isConnected = () => {
  return ChromeCastController.isConnected();
};

export const loadIntro = () => {
  // ChromeCastController.loadIntro();
  console.log("cc loadIntro - disabled");
};

export const loadIntroTeams = () => {
  console.log("cc loadTeams - disabled");
  //ChromeCastController.loadTeams();
};

export const loadIntroRounds = () => {
  console.log("cc loadRounds - disabled");
  //ChromeCastController.loadRounds();
};

export const loadIntroPrizes = () => {
  console.log("cc loadPrizes - disabled");
  //ChromeCastController.loadPrizes();
};

export const showAds = () => {
  console.log("cc showAds - disabled");
  //ChromeCastController.showAds();
};
export const hideAds = () => {
  console.log("cc hideAds - disabled");
  //ChromeCastController.hideAds();
};

export const loadNext = () => {
  console.log("cc loadNext - disabled");
  // ChromeCastController.loadNext();
};

export const loadPrev = () => {
  console.log("cc loadPrev - disabled");
  //ChromeCastController.loadPrev();
};

export const loadQuiz = (progress: any) => {
  console.log("cc loadQuiz - disabled");
  //ChromeCastController.loadQuiz(progress);
};

export const jumpTo = (state: any) => {
  console.log("cc jumpTo - disabled");
  //ChromeCastController.jumpTo(state);
};

export const jumpToPuzzle = () => {
  console.log("cc jumpToPuzzle - disabled");
  //ChromeCastController.jumpToPuzzle();
};

export const jumpToBreaker = () => {
  console.log("cc jumpToBreaker - disabled");
  //ChromeCastController.jumpToBreaker();
};

export const reload = () => {
  ChromeCastController.reload();
};

export const refresh = () => {
  ChromeCastController.refresh();
};

export const updateTeams = (teams: any) => {
  console.log("cc updateTeams - disabled");
  //ChromeCastController.updateTeams(teams);
};

export const updateTestTeams1 = () => {
  console.log("cc updateTestTeams1 - disabled");
  //ChromeCastController.updateTestTeams1();
};

export const updateTestTeams2 = () => {
  console.log("cc updateScore - disabled");
  //ChromeCastController.updateTestTeams2();
};

export const updateScore = (scores: any) => {
  console.log("cc updateScore - disabled");
  // ChromeCastController.updateScore(scores);
};

export const toggleDebug = () => {
  ChromeCastController.toggleDebug();
};

export const playMusic = () => {
  console.log("cc playMusic - disabled");
  // ChromeCastController.playMusic();
};

export const pauseMusic = () => {
  console.log("cc pauseMusic - disabled");
  // ChromeCastController.pauseMusic();
};

export const getSession = () => {
  return ChromeCastController.getSession();
};

export const quit = () => {
  ChromeCastController.quit();
};

const ChromeCast = {
  sendMessage,
  loadTestConfig,
  loadQuizConfig,
  connect,
  loadConfig,
  isConnected,
  loadIntro,
  loadIntroTeams,
  loadIntroRounds,
  loadIntroPrizes,
  showAds,
  hideAds,
  loadNext,
  loadPrev,
  loadQuiz,
  jumpTo,
  jumpToPuzzle,
  jumpToBreaker,
  reload,
  refresh,
  updateTeams,
  updateTestTeams1,
  updateTestTeams2,
  updateScore,
  toggleDebug,
  playMusic,
  pauseMusic,
  getSession,
  quit,
};

export default ChromeCast;
